import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const api_Url =
  process.env.NEXT_PUBLIC_API_URL || "https://api.itsonlyonestop.com";
import eventTracker from "../../../utils/analytics";
import EVENT_NAMES from "../../../utils/eventNames";

export const getAllCategoriesVendorsThunk = createAsyncThunk(
  "get-all-categories-vendors",
  async ({ data }) => {
    try {
      const response = await axios.get(
        `${api_Url}/api/vendor-list-by-category-new`,
        {
          params: data,
        }
      );

      return response?.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getVendorsbyCategoryIdThunk = createAsyncThunk(
  "get-vendors-by-category",
  async ({ data }) => {
    try {
      const response = await axios.get(`${api_Url}/api/user/homepagedata-new`, {
        params: data,
      });
      return response?.data;
    } catch (error) {
      console.log("error:", error);
    }
  }
);

// Category list

export const getAllCategoryListThunk = createAsyncThunk(
  "get-all-categories-list",
  async () => {
    try {
      const response = await axios.get(`${api_Url}/api/category`);

      return response?.data;
    } catch (error) {
      console.log(error);
      return response?.data;
    }
  }
);

export const getTotalVendorCountThunk = createAsyncThunk(
  "get-total-vendor-count",
  async (category_id) => {
    try {
      const response = await axios.get(`${api_Url}/api/get-total-vendor-count`);
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const addToFavouriteShopThunk = createAsyncThunk(
  "add-favourite-shop",
  async ({ token, favourite_user_id }) => {
    try {
      const response = await axios.post(
        `${api_Url}/api/favourite/add`,
        { favourite_user_id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const removeToFavouriteShopThunk = createAsyncThunk(
  "remove-favourite-shop",
  async ({ token, favourite_user_id }) => {
    try {
      const response = await axios.post(
        `${api_Url}/api/favourite/remove`,
        { favourite_user_id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getVendorDetailsThunk = createAsyncThunk(
  "get-vendors-details",
  async ({ data }, { getState }) => {
    try {
      const state = getState();

      const response = await axios.get(`${api_Url}/api/vendor-details`, {
        params: data,
      });
      const vendorName =
        response?.data?.data?.vendorDetails?.userDetail?.vendor_name ||
        "unknown";
      const vendorId =
        response?.data?.data?.vendorDetails?.userDetail?.id || "unknown";

      // Track Vendor Details Viewed Event
      //   eventTracker.track(EVENT_NAMES.VIEW_VENDOR_DETAILS, {
      //     userId: state?.auth?.user?.user?.id,
      //     email: state?.auth?.user?.user?.email,
      //     vendorId,
      //     vendorName,
      //   });
      return response?.data;
    } catch (error) {
      //   console.log(error);
    }
  }
);

// export const getVendorDetailsThunk = createAsyncThunk(
//     "get-vendors-details",
//     async ({ data }) => {
//         try {
//             const response = await axios.get(`${api_Url}/api/vendor/basic-details`,
//                 {
//                     params: data
//                 }
//             );
//             return response?.data;
//         } catch (error) {
//             console.log(error);
//         }
//     }
// );

export const getPackageDetailsThunk = createAsyncThunk(
  "get-package-details",
  async ({ token, package_id }) => {
    try {
      const response = await axios.get(`${api_Url}/api/package-details`, {
        params: { package_id },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getAlaCartItemDetailsThunk = createAsyncThunk(
  "get-alacartitem-details",
  async ({ token, user_menu_item_id }) => {
    try {
      const response = await axios.get(
        `${api_Url}/api/ala_carte_item-details`,
        {
          params: { item_id: user_menu_item_id },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getVendorAvailabilityDetailsThunk = createAsyncThunk(
  "get-vendor-availability-details",
  async ({ token, vendor_id }) => {
    try {
      const response = await axios.get(
        `${api_Url}/api/get-vendor-availability-details`,
        {
          params: { vendor_id },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const searchInCategoryThunk = createAsyncThunk(
  "homepagedata-search",
  async ({ token, data }, { getState }) => {
    try {
      const state = getState();
      eventTracker.track(EVENT_NAMES.SEARCH_ATTEMPT, {
        userId: state?.auth?.user?.user?.id,
        email: state?.auth?.user?.user?.email,
        searchTerm: data?.search || "",
        filters: data,
      });

      const response = await axios.get(
        `${api_Url}/api/user/homepagedata-search`,
        {
          params: data,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const searchInAllCategoryThunk = createAsyncThunk(
  "vendor-list-by-category-search",
  async ({ token, data }, { getState }) => {
    try {
      const state = getState();
      eventTracker.track(EVENT_NAMES.SEARCH_ATTEMPT, {
        userId: state?.auth?.user?.user?.id,
        email: state?.auth?.user?.user?.email,
        searchTerm: data?.search || "",
        filters: data,
      });
      const response = await axios.get(
        `${api_Url}/api/vendor-list-by-category-search`,
        {
          params: data,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getfavouriteListThunk = createAsyncThunk(
  "get-favourite-vendor-list",
  async ({ token, data }) => {
    try {
      const response = await axios.get(`${api_Url}/api/favourite/list`, {
        params: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getFilteredVendorThunk = createAsyncThunk(
  "get-filter-vendor",
  async ({ token, data }) => {
    try {
      const response = await axios.get(`${api_Url}/api/filter-vendor`, {
        params: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getMenuItemsListThunk = createAsyncThunk(
  "get-menu-item",
  async ({ token, data }) => {
    try {
      const response = await axios.get(`${api_Url}/api/vendor/menu-items`, {
        params: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (error) {}
  }
);

export const getpackageItemsListThunk = createAsyncThunk(
  "get-package-list",
  async ({ token, data }) => {
    try {
      const response = await axios.get(`${api_Url}/api/vendor/packages`, {
        params: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (error) {}
  }
);
